import { logError } from 'client/javascript/util/logger';
import { geoData } from 'client/javascript/geo';
import {
  isGeoConfiguredModule,
  isUserCountryInWhitelistedCountriesList,
  showModule,
  GEO_MODULE_SELECTOR
} from 'client/javascript/util/geolocation_based_module_rendering/helpers';

export const renderMultipleModules = async (config = {}, errorLabel = '') => {
  try {
    const { countryCode } = await geoData;
    const { selector = '', context = document } = config;

    context.querySelectorAll(`${selector}${GEO_MODULE_SELECTOR}`).forEach((moduleDomNode) => {
      const { conditionsToShow } = moduleDomNode.dataset;

      // nonGeoConfigured modules are rendered as is so we return early.
      if (!isGeoConfiguredModule(conditionsToShow)) {
        return;
      }

      if (isUserCountryInWhitelistedCountriesList(countryCode, conditionsToShow)) {
        showModule(moduleDomNode);
      } else {
        moduleDomNode.remove();
      }
    });
  } catch (error) {
    // `errorLabel` is optional, its value have to be a name of a geobased module for which the function is used
    // and it uses to sort out by an error message in the Rollbar
    const msgDetails = errorLabel ? ` in ${errorLabel}` : '';
    logError(`[Geolocation Based Rendering] renderMultipleModules failed${msgDetails}: ${error.message}`, error);
  }
};
